import common from './common'

const geolocation = {

  /**
   * Requisita ao usuário a sua localização
   *
   * @param callback
   */
  getUserLocation: (callback, error) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(callback, error)
    }
  },

  userGeolocation: async () => {
    let cookieCity = null;
    let cookieLocale = null;
    let cookieName = null;
    let cookieUf = null;
    const cookies = document.cookie.split(';');

    for (const element of cookies) {
      const temp = element.trim();
      if (temp.startsWith('__geo_city=')) cookieCity = temp.substring('__geo_city='.length);
      if (temp.startsWith('__geo_locale=')) cookieLocale = temp.substring('__geo_locale='.length);
      if (temp.startsWith('__geo_name=')) cookieName = temp.substring('__geo_name='.length);
      if (temp.startsWith('__geo_uf=')) cookieUf = temp.substring('__geo_uf='.length);
    }

    const isGeolocationGranted = await navigator.permissions.query({ name: "geolocation" })
      .then((result) => result.state === "granted")
      .catch(() => false);

    if (cookieCity && cookieLocale && cookieName && cookieUf && !isGeolocationGranted) {
      const city = cookieCity;
      const locale = cookieLocale;
      const name = cookieName;
      const uf = cookieUf;

      await geolocation.runWeatherRequestsInParallel(locale, city);
      common.dynamicLink(city, name, uf);
      return;
    }

    geolocation.getUserLocation((position) => {
      const url = "/json/minha-localizacao";
      const xhttp = new XMLHttpRequest();

      xhttp.onreadystatechange = async function () {
        if (this.readyState === 4 && this.status === 200) {
          let response;

          try {
            response = JSON.parse(this.response);
          } catch (e) {
            console.error("Resposta inválida do servidor:", this.response);
            fallbackToSaoPaulo();
            return;
          }

          const locationData = response?.data?.[0];
          if (!locationData) {
            console.warn("Dados de localização não encontrados:", response);
            fallbackToSaoPaulo();
            return;
          }

          const { idlocale, idcity, city, uf } = locationData;

          await geolocation.runWeatherRequestsInParallel(idlocale, idcity);
          common.dynamicLink(idcity, city, uf);
        }
      };

      xhttp.open("POST", url, true);
      xhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      xhttp.send(`latitude=${position.coords.latitude}&longitude=${position.coords.longitude}`);
    }, () => {
      fallbackToSaoPaulo();
    });

    async function fallbackToSaoPaulo() {
      await geolocation.runWeatherRequestsInParallel(3477, 558);
      common.dynamicLink(558, 'São Paulo', 'SP');
    }
  },

  /**
   * Executa as três requests em paralelo usando Promise.all
   */
  runWeatherRequestsInParallel: async (idlocale, idcity) => {
    return Promise.all([
      geolocation.renderWeatherNowByGeolocation(idlocale, idcity),
      geolocation.updateDaysCards(idlocale),
      geolocation.updateNearbyBeaches(idlocale),
      geolocation.updateRainForecastChart(idlocale, idcity)
    ]);
  },

  /**
   * Create component with forecast now for geolocated city
   * Agora retorna uma Promise
   */
  renderWeatherNowByGeolocation: (idlocale, idcity) => {
    return new Promise((resolve, reject) => {
      const url = `/json/myclimatempo/user/weatherNow?idlocale=${idlocale}`;
      const xhttp = new XMLHttpRequest();

      xhttp.onreadystatechange = function () {
        if (this.readyState !== 4) return;
        if (this.status !== 200) {
          reject(new Error('Erro na requisição de weatherNow'));
          return;
        }

        let response;
        try {
          response = JSON.parse(this.response);
        } catch (e) {
          console.error("Erro ao fazer parse da resposta de weatherNow:", e);
          reject(e);
          return;
        }

        const dataPath = response?.data?.getWeatherNow?.[0]?.data?.[0];
        if (!dataPath || !dataPath.locale || !dataPath.weather) {
          console.warn("Dados incompletos para exibir o clima atual:", response);
          resolve();
          return;
        }

        const { locale, weather } = dataPath;
        const slug = common.createSlug(locale.city);
        const acronym = (locale.ac === 'BR') ? locale.uf : locale.ac;
        const cityName = `${locale.city}, ${acronym}`;
        const cityUrl = `${locale.idcity}/${slug}-${acronym.toLowerCase()}`;
        const todayUrl = `/previsao-do-tempo/cidade/${cityUrl}`;
        const tomorrowUrl = `/previsao-do-tempo/amanha/cidade/${cityUrl}`;
        const city15DaysUrl = `/previsao-do-tempo/15-dias/cidade/${cityUrl}`;

        // Salva cookies se estiver na home
        if ($('[data-current-weather]').length > 0) {
          const domain = window.location.hostname;
          document.cookie = `__geo_locale=${idlocale}; domain=.${domain}`;
          document.cookie = `__geo_city=${idcity}; domain=.${domain}`;
          document.cookie = `__geo_name=${locale.name}; domain=.${domain}`;
          document.cookie = `__geo_uf=${locale.uf}; domain=.${domain}`;
        }

        // Exibe o widget geolocalizado
        $('[data-id=geolocated]').removeClass('-hidden-geolocated');
        $('[data-id=geolocated] .city').html(cityName);
        $('[data-id=geolocated] .temperature').html(`${weather.temperature ?? '-'}&deg;`);
        $('[data-id=geolocated] .ico').attr('src', `/dist/images/v2/svg/outline/${weather.icon}.svg`);

        const basePath = window.location.href.includes('agroclima')
          ? `/agroclima/previsao-do-tempo/15-dias/cidade/`
          : `/previsao-do-tempo/cidade/`;

        $('[data-id=geolocated] .link').attr('href', `${basePath}${cityUrl}`);

        // Se tiver bloco completo de clima atual
        if ($('[data-current-weather]').length > 0) {
          const icon = $('<img>', {
            src: `/dist/images/v2/svg/${weather.icon}.svg`,
            alt: `Temperatura agora em ${cityName}`,
            width: 40,
            height: 40
          });

          $('#current-weather-city').html(cityName);
          $('#current-weather-icon').html(icon);
          $('#current-weather-temperature').html(`${weather.temperature ?? '-'}&deg;`);
          $('#current-weather-condition').html(`${weather.condition ?? ''}`);
          $('#current-weather-sensation').html(`${weather.sensation ?? '-'}&deg;`);
          $('#current-weather-humidity').html(`${weather.humidity ?? '-'}%`);
          $('#current-weather-pressure').html(`${weather.pressure ?? '-'} hPa`);
          $('#current-weather-wind').html(`${weather.windVelocity ?? '-'}km/h`);
          $('#current-weather-updated-at').html(`${weather.dateUpdate ?? ''}`);
          $('[data-id=Card_TempoAgora_Button_Today]').attr('href', todayUrl);
          $('[data-id=Card_TempoAgora_Button_Tomorrow]').attr('href', tomorrowUrl);
          $('[data-id=Card_TempoAgora_Button_15days]').attr('href', city15DaysUrl);

          $('[data-current-weather] .shimmer-placeholder').removeClass('shimmer-placeholder');
        }

        // Disparo de evento para analytics
        geolocation.errorHitCurrentWeather(weather);
        resolve();
      };

      xhttp.open("POST", url, true);
      xhttp.send();
    });
  },

  updateDaysCards: (idlocale) => {
    return new Promise((resolve, reject) => {
      const url = `/json/myclimatempo/user/forecastFiveDays?idlocale=${idlocale}`;
      const xhttp = new XMLHttpRequest();
      
      xhttp.onreadystatechange = function () {
        if (this.readyState !== 4) return;
        if (this.status !== 200) {
          reject(new Error('Erro na requisição de forecastFiveDays'));
          return;
        }
        let response;
        let data;

        try {
          response = JSON.parse(this.response);

          const infoCity = response?.infoCity;
          let todayUrl = '', tomorrowUrl = '', city15DaysUrl = '';

          if (infoCity) {
            const slug = common.createSlug(infoCity.city);
            const acronym = (infoCity.ac === 'BR') ? infoCity.uf : infoCity.ac;
            const cityUrl = `${infoCity.idcity}/${slug}-${acronym.toLowerCase()}`;

            todayUrl = `/previsao-do-tempo/cidade/${cityUrl}`;
            tomorrowUrl = `/previsao-do-tempo/amanha/cidade/${cityUrl}`;
            city15DaysUrl = `/previsao-do-tempo/15-dias/cidade/${cityUrl}`;

            $('#Botao_card_previsao_1').attr('href', todayUrl);
            $('#Botao_card_previsao_2').attr('href', tomorrowUrl);
            $('#Botao_card_previsao_3').attr('href', city15DaysUrl);
          }

          data = response.data.getFiveDaysForecast.slice(0, 3).map((forecast) => {
            let rainDropsSrc = Array(3).fill('/dist/images/gota-cinza.png');       

            if (forecast.rain.precipitation > 0 && forecast.rain.precipitation < 10) {
              rainDropsSrc = ["/dist/images/gota-azul.png", "/dist/images/gota-cinza.png", "/dist/images/gota-cinza.png"];
            } else if (forecast.rain.precipitation >= 0 && forecast.rain.precipitation < 30) {
              rainDropsSrc = ["/dist/images/gota-azul.png", "/dist/images/gota-azul.png", "/dist/images/gota-cinza.png"];
            } else if (forecast.rain.precipitation >= 30) {
              rainDropsSrc = Array(3).fill("/dist/images/gota-azul.png");
            }

            return {
              icon: forecast.textIcon.icon.day,
              rainDropsSrc: rainDropsSrc,
              minTemp: `${forecast.temperature.min}&deg;`,
              maxTemp: `${forecast.temperature.max}&deg;`,
              rainLabel: `${forecast.rain.precipitation}mm - ${forecast.rain.probability}%`,
            }
          })

          data.forEach((forecast, index) => {
            const dayIndex = index + 1;

            $(`#forecast-card-rain-drops-wrapper-${dayIndex}`).empty();

            forecast.rainDropsSrc.forEach((src, i) => {
              const img = $('<img>', {
                class: "lazyload _flex _width-auto",
                src: src,
                alt: `Gota de chuva ${i + 1}`,
                width: 10,
                height: 10
              });
              $(`#forecast-card-rain-drops-wrapper-${dayIndex}`).append(img);
            })

            $(`#day-forecast-card-icon-${dayIndex}`).attr('src', `/dist/images/v2/svg/${forecast.icon}.svg`);
            $(`#forecast-card-min-temp-${dayIndex}`).html(forecast.minTemp);
            $(`#forecast-card-max-temp-${dayIndex}`).html(forecast.maxTemp);
            $(`#forecast-card-rain-${dayIndex}`).html(forecast.rainLabel);
          })
        } catch (e) {
          console.error("Erro ao fazer parse da resposta de forecastFiveDays:", e);
          reject(e);
          return;
        }
        resolve();
      }

      xhttp.open("POST", url, true);
      xhttp.send();
    });
  },

  updateRainForecastChart: (idlocale, idcity) => {
    const url = `/json/myclimatempo/user/rainForecastSevenDays?idlocale=${idlocale}`;
    const $container = $('#rain-forecast-chart');

    fetch(url)
      .then(res => res.json())
      .then(data => {
        if (data.infoCity) {
          const city = data.infoCity;
          const cityToSlug = common.createSlug(city.city)
          const acronym = (city.ac === 'BR') ? city.uf : city.ac;
          const citySlug = `${cityToSlug}-${acronym.toLowerCase()}`

          if (city.idcity && citySlug && city.city) {
            const cityLink = $('[id^="Link_"][id$="_card_volume_chuva"]');

            cityLink.attr('href', `/previsao-do-tempo/cidade/${city.idcity}/${citySlug}`);
            cityLink.text(city.city);
            cityLink.attr('title', `Ver a previsão completa para ${city.city}`);
            cityLink.attr('id', `Link_${citySlug}_card_volume_chuva`);
          }
        }

        const rainData = Array.isArray(data.rain) ? data.rain : [];
        if (!rainData.length) {
          $container.html('<div>Sem dados de chuva.</div>');
          return;
        }
        let html = '';
        rainData.forEach(day => {
          const mm = day.precipitation;
          let dateLabel = '-';
          if (day.date) {
            const [_, month, dayNum] = day.date.split('-');
            dateLabel = `${dayNum}/${month}`;
          }
          const dayWeek = day.dayWeek || '';
          html += `
            <div class="-gray-dark-2 -font-12 _flex _align-center _flex-column">
              <span>${mm}mm</span>
              <div class="volume-bar _margin-b-10 _margin-t-10" data-text="${mm}mm">
                <span style="height: ${mm}%"></span>
              </div>
              <span>${dayWeek}</span>
              <span>${dateLabel}</span>
            </div>
          `;
        });
        $container.html(html);
      })
      .catch((e) => {
        console.log(e)
        $container.html('<div>Erro ao carregar dados de chuva.</div>');
      });
  },

  updateNearbyBeaches: (idlocale) => {
    return new Promise((resolve, reject) => {
      const url = `/json/myclimatempo/user/nearbyBeaches?idlocale=${idlocale}`;
      const xhttp = new XMLHttpRequest();

      xhttp.onreadystatechange = function () {
        if (this.readyState !== 4) return;
        if (this.status !== 200) {
          reject(new Error('Erro na requisição de nearbyBeaches'));
          return;
        }
        let response;
        try {
          response = JSON.parse(this.response);
        } catch (e) {
          console.error("Erro ao fazer parse da resposta de nearbyBeaches:", e);
          reject(e);
          return;
        }
        // response is an array of beaches
        const beaches = response;
        // Find the container: the first <ul> inside the .card-no-top after the 'Praias próximas' title
        // (adjust selector if needed)
        const $container = $("#nearby-beaches-card-ul");
        if (!$container.length) {
          resolve();
          return;
        }
        $container.empty();
        if (!beaches || !beaches.length) {
          $container.append('<li>Nenhuma praia próxima encontrada.</li>');
          resolve();
          return;
        }
        beaches.forEach((beach, idx) => {
          // Rain drops logic (same as Twig)
          let rainDrops = '';
          const prec = parseFloat(beach.weather.rain.precipitation);
          if (prec === 0) {
            rainDrops = `<img class="_width-10 lazyload" width="10" height="10" data-src="/dist/images/gota-cinza.png" alt="">`.repeat(2) +
                        `<img class="_width-10 _margin-r-5 lazyload" width="10" height="10" data-src="/dist/images/gota-cinza.png" alt="">`;
          } else if (prec >= 10 && prec < 30) {
            rainDrops = `<img class="_width-10 lazyload" width="10" height="10" data-src="/dist/images/gota-azul.png" alt="">` +
                        `<img class="_width-10 lazyload" width="10" height="10" data-src="/dist/images/gota-azul.png" alt="">` +
                        `<img class="_width-10 _margin-r-5" width="10" height="10" src="/dist/images/gota-cinza.png" alt="">`;
          } else if (prec >= 30) {
            rainDrops = `<img class="_width-10 lazyload" width="10" height="10" data-src="/dist/images/gota-azul.png" alt="">`.repeat(2) +
                        `<img class="_width-10 _margin-r-5 lazyload" width="10" height="10" data-src="/dist/images/gota-azul.png" alt="">`;
          } else {
            rainDrops = `<img class="_width-10 lazyload" width="10" height="10" data-src="/dist/images/gota-cinza.png" alt="">` +
                        `<img class="_width-10 _margin-r-5 lazyload" width="10" height="10" data-src="/dist/images/gota-cinza.png" alt="">`;
          }
          $container.append(`
            <li class="item _padding-lr-10 _flex _align-center _space-between${idx !== 0 ? ' _padding-t-20' : ''}${idx !== beaches.length - 1 ? ' _padding-b-20 _border-b-light-1' : ''}">
              <div class="_flex _align-center">
                <img class="lazyload _margin-r-20" data-src="/dist/images/v2/svg/${beach.weather.textIcon.icon.day}.svg" width="33" height="33" alt="${beach.weather.textIcon.text.pt}" />
                <div>
                  <a href="/previsao-do-tempo/litoral/${beach.info.idbeach}/${beach.info.slugBeach}-${beach.info.uf.toLowerCase()}" class="-bold -gray-dark-2 _margin-b-5 _block" title="${beach.info.beach}">${beach.info.beach}</a>
                  <p class="-gray _flex _align-center">
                    <img src="/dist/images/v2/svg/ic-arrow-min.svg" alt="Temperatura mínima" class="_margin-r-5 _margin-b-3" width="12px" height="12px">
                    ${beach.weather.temperature.min}
                    <img src="/dist/images/v2/svg/ic-arrow-max.svg" alt="Temperatura máxima" class="_margin-l-10 _margin-r-5 _margin-b-3" width="12px" height="12px">
                    ${beach.weather.temperature.max}
                  </p>
                  <p class="-gray _flex _align-center">
                    ${rainDrops}
                    ${beach.weather.rain.precipitation}mm - ${beach.weather.rain.probability}%
                  </p>
                </div>
              </div>
            </li>
          `);
        });
        resolve();
      };

      xhttp.open("POST", url, true);
      xhttp.send();
    });
  },

  errorHitCurrentWeather: (weather) => {
    if (!weather.icon) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'event': 'error_hit', 'name': 'data_aggregator_now_icon' });
    }

    if (!weather.temperature) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ 'event': 'error_hit', 'name': 'data_aggregator_now_temperature' });
    }
  }

}

export default geolocation
